import { Injectable } from '@angular/core';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { Publication } from '@portal-core/publications/models/publication.model';

@CollectionStateSelectors({
  stateType: PublicationsState
})
@State<PublicationsState>({
  name: PublicationsState.source,
})
@Injectable()
export class PublicationsState extends CollectionStateBase {
  static source = 'Publications';
  getSource(): string {
    return PublicationsState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class PublicationsDataService extends CollectionDataServiceBase<Publication> {
  constructor(protected store: Store) {
    super(store, PublicationsState);
  }
}
